import { render, staticRenderFns } from "./e-pager.vue?vue&type=template&id=48fee0c7&scoped=true"
import script from "./e-pager.vue?vue&type=script&lang=js"
export * from "./e-pager.vue?vue&type=script&lang=js"
import style0 from "./e-pager.vue?vue&type=style&index=0&id=48fee0c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fee0c7",
  null
  
)

export default component.exports